export const tr = {
    'avg-click-price-mandatory': 'Ortalama tıklama fiyatı belirtilmedi',
    'avg-cpc-ratio-weekly-budget-limit-error':
        'Haftalık bütçeyi artırın. Haftalık bütçe minimum {limit} dönüşüm için yeterli olmalıdır.',
    'invalid-profitability': 'Maliyet yüzdesi {from} ile {to} arasında olmalıdır',
    'roi-coef-mandatory': 'ROI katsayısı belirtilmedi',
    'too-big-avg-click-price': 'Ortalama tıklama fiyatı maksimum {limit} {currency} olabilir',
    'too-big-avg-cpa-price': 'Ortalama dönüşüm fiyatı maksimum {limit} {currency} olabilir',
    'too-big-daily-budget': 'Günlük bütçe tutarı maksimum {limit} {currency} olabilir',
    'too-big-max-click-price': 'Maksimum tıklama fiyatı {limit} {currency} değerine eşit veya altında olmalıdır',
    'too-big-week-bundle': 'Haftalık tıklama sayısı maksimum {limit} olabilir',
    'too-big-weekly-budget': 'Haftalık bütçe tutarı maksimum {limit} {currency} olabilir',
    'too-small-avg-click-price': 'Ortalama tıklama fiyatı minimum {limit} {currency} olabilir',
    'too-small-avg-cpa-price': 'Ortalama dönüşüm fiyatı minimum {limit} {currency} olabilir',
    'too-small-daily-budget': 'Günlük bütçe tutarı minimum {limit} {currency} olabilir',
    'too-small-max-click-price': 'Maksimum tıklama fiyatı {limit} {currency} değerine eşit veya üstünde olmalıdır',
    'too-small-roi-coef': 'Kârlılık katsayısı şu değerin üzerinde olmalıdır: {limit} ',
    'too-small-week-bundle': 'Haftalık tıklama sayısı minimum {limit} olabilir',
    'too-small-weekly-budget': 'Haftalık bütçe tutarı minimum {limit} {currency} olabilir',
    'week-bundle-mandatory': 'Tıklama sayısı belirtilmedi',
    'weekly-budget-mandatory': 'Haftalık bütçe belirtilmedi'
};
